// Hand over at the end of the shift (T11): the latest note is the first thing the next technician sees.
import { useState } from 'react';

import type { BuildDetailResponse } from '../../api/generated/BuildDetailResponse';
import type { useBuildActions } from '../../api/queries';
import { Button, ErrorPanel, TextField } from '../../design/components';
import { formatDateTime } from '../../design/format';

export function HandoverPanel({
    build,
    actions,
    canAct,
}: {
    build: BuildDetailResponse;
    actions: ReturnType<typeof useBuildActions>;
    canAct: boolean;
}) {
    const [note, setNote] = useState('');
    // The latest note also heads the build's page; this panel keeps the history and the form.
    const [latest, ...older] = build.handovers;
    // The latest note is shown in the build's header, first thing; this panel keeps the history and the form.
    return (
        <section className="sf-card sf-stack" aria-labelledby="handover-heading">
            <h2 id="handover-heading">Shift handover</h2>
            {latest ? (
                <p>
                    Latest: <strong>{latest.left.displayName}</strong> ({formatDateTime(latest.left.at)}): {latest.note}
                </p>
            ) : (
                <p className="sf-muted">No handover notes yet.</p>
            )}
            {older.length > 0 ? (
                <details>
                    <summary>Earlier notes ({older.length})</summary>
                    <ul>
                        {older.map((handover) => (
                            <li key={handover.left.at}>
                                {handover.left.displayName} ({formatDateTime(handover.left.at)}): {handover.note}
                            </li>
                        ))}
                    </ul>
                </details>
            ) : null}
            {canAct ? (
                <div className="sf-stack">
                    <TextField label="Note for the next shift" value={note} onChange={setNote} multiline />
                    <div>
                        <Button
                            disabled={note.trim() === '' || actions.handOver.isPending}
                            onClick={() => {
                                actions.handOver.mutate(note, {
                                    onSuccess: () => {
                                        setNote('');
                                    },
                                });
                            }}
                        >
                            Leave the note
                        </Button>
                    </div>
                    {actions.handOver.isError ? <ErrorPanel error={actions.handOver.error} /> : null}
                </div>
            ) : null}
        </section>
    );
}
